import React, { useState, useEffect, useRef } from "react"
import { AxiosGetData } from "../../context/axiosfunction"
import { useGlobalContext } from "../../context/provider"
import FilterDesktop from "./FilterDesktop"
import FilterTablet from "./FilterTablet"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const MainSearch = ({ search, tag }) => {
    const { screen, API, headers, privateKey } = useGlobalContext()
    const [selectdata, setselectdata] = useState(null)
    const [AllBook, setAllBook] = useState([])
    const [catetypeBook, setcatetype] = useState([])
    const [loading, setLoading] = useState(true)
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 150); // เปลี่ยน 150 ตามต้องการ
        onScroll(); // เช็คตอนโหลดครั้งแรก
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);


    async function enrichTypeCate(
        data,
        allTypes,
        allCates
    ) {
        // สร้างดิกชันนารี O(1) lookup
        const typeNameById = new Map(allTypes.map(t => [Number(t.value), String(t.label)]));
        const cateNameById = new Map(allCates.map(c => [Number(c.value), String(c.label)]));

        return data.map(item => ({
            type_id: item.type_id,
            type_name: typeNameById.get(Number(item.type_id)) ?? String(item.type_id),
            category: item?.cate_ids?.map(cid => ({
                id: cid,
                name: cateNameById.get(Number(cid)) ?? String(cid),
            })),
        }));
    }

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true)
                const alldata = await AxiosGetData(API, `/api/all_ebook?page=1`, headers, privateKey)
                const allSelect = await AxiosGetData(API, '/api/select_search_data', headers, privateKey)
                const test = await AxiosGetData(API, '/api/type_cate_data', headers, privateKey)

                const formcate = await enrichTypeCate(test, allSelect?.book_type, allSelect?.category)


                setcatetype(formcate)
                setAllBook(alldata)
                setselectdata(allSelect)
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }

        getData()
    }, [API, headers, privateKey])


    return (
        <div className="flex items-center flex-col mx-0 xl:mx-[10%] my-[1.5em] relative">
            {screen === 'desktop' &&
                <div className="aspect-[10/1] w-[100%] xl:w-[1200px] bg-slate-400"></div>
            }

            {loading ?
                <img className="w-[50%] md:w-[40%] xl:w-[20%] my-[2em]" src="https://eve-image.eveebook.com/image.eveebook/web_image/loading.gif" alt="load" />
                : <>
                    {screen === 'desktop' ?
                        <FilterDesktop selectdata={selectdata} ebook={AllBook} setebook={setAllBook} catetypeBook={catetypeBook} search={search} tag={tag} />
                        :
                        <FilterTablet selectdata={selectdata} ebook={AllBook} setebook={setAllBook} catetypeBook={catetypeBook} search={search} tag={tag} />
                    }
                </>}
            {show &&
                <div className=" fixed right-[30px] bottom-[30px]">
                    <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="w-[40px] opacity-[80%] h-[40px] rounded-full bg-[#F5F6F8] cursor-pointer">
                        <FontAwesomeIcon icon={faArrowUp} />
                    </button>
                </div>
            }

        </div>
    )

}


export default MainSearch